import React, { FC } from 'react';

import { CSSObject } from 'styled-components';

import { Box } from '@adsk/alloy-react-box';

type ReferencePickerBlockTitleProps = {
  style?: CSSObject;
  className?: string;
  isAccordionVariant?: boolean;
  children?: React.ReactNode;
};

const ReferencePickerBlockTitle: FC<ReferencePickerBlockTitleProps> = ({
  style,
  className,
  isAccordionVariant,
  children,
}) => {
  return (
    <Box
      data-testid="reference-picker-block-title"
      className={className}
      typography="bodyMedium"
      color="charcoal900"
      backgroundColor="charcoal050"
      padding={isAccordionVariant ? '8px 16px' : '14px 16px'}
      style={style}
    >
      {children}
    </Box>
  );
};

export default ReferencePickerBlockTitle;
